import React from 'react'

const wrapperStyle = {
  position: 'fixed',
  background: 'red',
  zIndex: '10000',
  top: '0',
  width: '100%',
  color: 'white'
}

export default function OfflineIndicator () {
  return (
    <div style={wrapperStyle} className='text-center'>
      No Internet Connection
    </div>
  )
}



// WEBPACK FOOTER //
// ./components/Offline/index.js